/**
 * @file Album Purchased Custom Prints reducer.
 */

import {
  UPDATE_FILTER,
  RESET_FILTER,
} from '../actions/album-purchased-custom-prints';
import { ORDER_STATUS } from '../constants/pro-custom-prints';

export const initialState = {
  filter: {
    orderStatus: ORDER_STATUS.PENDING,
    limit: 20,
    offset: 0,
  },
};

const albumPurchasedCustomPrintsReducer = (
  state = initialState,
  action = {},
) => {
  switch (action.type) {
    case UPDATE_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.filter,
        },
      };

    case RESET_FILTER:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default albumPurchasedCustomPrintsReducer;
